module.exports = __webpack_public_path__ + "static/media/33.7ec3be9c.jpg";